// selectors
export const getWeeklyMealPlan = state => {
  return state.MealPlanner.mealPlan;
};

export const getMondayMeals = state => {
  return state.MealPlanner.mealPlan.Monday;
};

export const getTuesdayMeals = state => {
  return state.MealPlanner.mealPlan.Tuesday;
};

export const getWednesdayMeals = state => {
  return state.MealPlanner.mealPlan.Wednesday;
};

export const getThursdayMeals = state => {
  return state.MealPlanner.mealPlan.Thursday;
};

export const getFridayMeals = state => {
  return state.MealPlanner.mealPlan.Friday;
};

export const getSaturdayMeals = state => {
  return state.MealPlanner.mealPlan.Saturday;
};

export const getSundayMeals = state => {
  return state.MealPlanner.mealPlan.Sunday;
};

export const getPastMealPlans = state => {
  return state.MealPlanner.pastMealPlans;
};
